<div>
  <ng-template #sort let-order="order" let-field="field">
    <div class="pull-right sort">
      <i
        class="fas fa-sort"
        *ngIf="!field || !order || order.indexOf(field) < 0"
      ></i>
      <i class="fas fa-sort-up" *ngIf="order == field"></i>
      <i class="fas fa-sort-down" *ngIf="order == '-' + field"></i>
    </div>
  </ng-template>

  <div class="kt-widget filter">
    <div class="form-group">
      <label for="">Created Date</label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="filter.date"
        (keyup.enter)="getRecords(false, 1)"
        (change)="getRecords(false, 1)"
      />
    </div>

    <div class="form-group">
      <label for="">Product SKU</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filter.sku"
        (keyup.enter)="getRecords(false, 1)"
      />
    </div>

    <div class="form-group">
      <label for="">Product Name</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filter.product"
        (keyup.enter)="getRecords(false, 1)"
      />
    </div>

    <div class="form-group">
      <label for="">Product Dept</label>
      <select
        class="form-control"
        [(ngModel)]="filter.rfq_dept"
        (change)="getRecords(false, 1)"
      >
        <option value="0">All</option>
        <option *ngFor="let pt of settingsSvc.productDepartments" [value]="pt.id">
          {{ pt.text }}</option
        >
      </select>
    </div>

    <div class="form-group">
      <label for="">Starred</label>
      <select
        class="form-control"
        [(ngModel)]="filter.starred"
        (change)="getRecords(false, 1)"
      >
        <option value="-1">All</option>
        <option value="1">Starred</option>
        <option value="0">Not Starred</option>
      </select>
    </div>

    <div class="form-group">
      <label for="">Discontinued</label>
      <select
        class="form-control"
        [(ngModel)]="filter.discontinued"
        (change)="getRecords(false, 1)"
      >
        <option value="2">All SKUs</option>
        <option value="-1">Active SKUs</option>
        <option value="1">Discontinued SKUs only</option>
      </select>
    </div>

    <div class="form-group mw-200" *ngIf="authService.loginUser.role > 2">
      <label for="">Sourcing Assignee</label>
      <ng-select
        [items]="goStaff"
        bindValue="id"
        [(ngModel)]="filter.sourcing"
        (change)="getRecordTimeout()"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
            >×</span
          >
          {{ item.firstname + ' ' + item.lastname }}
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-index="index"
          let-search="searchTerm"
        >
          <h6>
            {{ item.firstname + ' ' + item.lastname }}
          </h6>
        </ng-template>
      </ng-select>
    </div>

    <div class="form-group mw-200" *ngIf="authService.loginUser.role > 2">
      <label for="">Sales Assignee</label>
      <ng-select
        [items]="goTeam"
        bindValue="id"
        [(ngModel)]="filter.goteam"
        (change)="getRecordTimeout()"
      >
        <!-- <ng-template ng-label-tmp let-item="Factory -->
        <ng-template
          ng-option-tmp
          let-item=" item"
          let-index="index"
          let-search="searchTerm"
        >
          <h6> {{ item.firstname + ' ' + item.lastname }} </h6>
        </ng-template>
      </ng-select>
    </div>

    <div class="form-group mw-200">
      <!-- <mat-checkbox color="primary" [(ngModel)]="filter.discontinued"
                (change)="getRecords(false, 1)">
                Include Discontinued
            </mat-checkbox>  -->
      <br />
      <button class="btn btn-outline-info btn-sm mr-1" (click)="resetFields()">
        <i class="fas fa-eraser"></i> Reset Filters
      </button>

      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-outline-primary btn-sm"
          id="dropdownBasic1"
          ngbDropdownToggle
        >
          <span>Export SKUs </span>
          <i class="fas fa-caret-down"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="action-button">
          <button ngbDropdownItem (click)="exportListToPdf()">
            <i class="fas fa-file-pdf"></i> Export to PDF
          </button>
          <button ngbDropdownItem (click)="exportListToPdf(true)">
            <i class="fas fa-file-pdf"></i> Export Alternate SKUs to PDF
          </button>
          <button ngbDropdownItem (click)="exportListToCsv()">
            <i class="fas fa-file-csv"></i> Export to CSV
          </button>
          <button ngbDropdownItem (click)="exportListToCsv(true)">
            <i class="fas fa-file-csv"></i> Export Alternate SKUs to CSV
          </button>
        </div>
      </div>
    </div>

    <button
      class="btn btn-primary btn-sm mr-2"
      *ngIf="checkedCount > 0"
      (click)="assignSelected()"
    >
      <i class="fas fa-users"></i> Assign SKUs to Staff
    </button>
  </div>

  <div class="overflow-auto">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th
            *ngIf="
              authService.loginUser.role > 2 && authService.loginUser.prwx == 7
            "
          >
            <mat-checkbox
              color="primary"
              [(ngModel)]="checkedAll"
              (ngModelChange)="checkAll()"
            >
            </mat-checkbox>
          </th>
          <th
            class="link"
            (click)="setOrder('created_at')"
            [translate]="'TITLES.DATE_TIME_CREATED'"
          >
            Created Date/Time
            <ng-container
              *ngTemplateOutlet="
                sort;
                context: {
                  order: filter.order,
                  field: 'created_at',
                }
              "
            >
            </ng-container>
          </th>
          <th
            class="link"
            (click)="setOrder('product_name')"
            [translate]="'TITLES.PRODUCT'"
          >
            Product Name
            <ng-container
              *ngTemplateOutlet="
                sort;
                context: {
                  order: filter.order,
                  field: 'product_name',
                }
              "
            >
            </ng-container>
          </th>

          <th> Pipelines </th>

          <th *ngIf="authService.loginUser.role >= 2"> Sourcing Assignees </th>

          <th class="text-center">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="rfqService.gettingRecords">
          <td colspan="10" class="text-center">
            <br />
            <h6 [translate]="'GENERAL.GETTING_RECORDS'">
              <i class="fas fa-spinner fa-spin"></i> Getting records...
            </h6>
            <br />
          </td>
        </tr>
        <tr *ngIf="!rfqService.gettingRecords && rfqRecord.data.length == 0">
          <td colspan="10" class="text-center">
            <br />
            <h6 class="text-warning">No record found.</h6>
            <br />
          </td>
        </tr>
        <tr
          *ngFor="let r of rfqRecord.data; let i = index"
          [ngClass]="{
            checked: checked[r.id],
            'low-quantity':
              r.qty_limit_notify > 0 && r.qty_available <= r.qty_limit_notify,
          }"
        >
          <td
            *ngIf="
              authService.loginUser.role > 2 && authService.loginUser.prwx == 7
            "
          >
            <mat-checkbox
              color="primary"
              [(ngModel)]="checked[r.id]"
              (ngModelChange)="countChecked()"
            >
            </mat-checkbox>
          </td>
          <td> {{ r.created_at | date: 'medium' }} <br /> </td>
          <td class="text-capitalize">
            <a
              href="javascript:;"
              class="star mr-1"
              (click)="rfqService.toggleStarred(r)"
              ngbPopover="{{ r.starred ? r.starred_notes : '' }}"
              placement="top"
              triggers="mouseenter:mouseleave"
              title="{{ r.starred ? '' : 'Mark this SKU as starred' }}"
            >
              <i class="fas fa-star text-success" *ngIf="r.starred == 1"></i>
              <i class="far fa-star text-secondary" *ngIf="r.starred == 0"></i>
            </a>

            <a
              href="javascript:;"
              title="View Details"
              [ngClass]="{ 'text-linethrough': r.is_discontinued == 1 }"
              class="link mr-1"
              (click)="showDetails(r)"
            >
              <span class="sku" *ngIf="r.internal_sku && r.internal_sku.length > 3">
                [{{ r.internal_sku }}]
              </span>
              {{ r.product_name }}
            </a>
            <!-- <span class="mr-1"> {{ r.product_category }} </span>
                        <small class="text-warning mr-1"> {{ getQuoteType(r.rfq_quote_type) }}</small> -->

            <div class="statuses">
              <span
                *ngIf="r.status == 1 || r.posted_quotes_count == 0"
                class="kt-badge kt-badge--info kt-badge-sm kt-badge--inline kt-badge--pill"
                [translate]="'QUOTE_STATUS.OUT_FOR_QUOTE'"
                >Out for Quote</span
              >

              <span
                *ngIf="r.price_negotiation_count > 0"
                class="
                  kt-badge kt-badge--warning kt-badge-sm kt-badge--outline kt-badge--pill
                "
              >
                {{ r.price_negotiation_count }} Price Requests</span
              >

              <span
                *ngIf="r.requote_requests_count > 0"
                class="
                  kt-badge kt-badge--danger kt-badge-sm kt-badge--outline kt-badge--pill
                "
              >
                {{ r.requote_requests_count }} Re-Quote Requests</span
              >

              <span
                *ngIf="r.posted_quotes_count > 0"
                class="
                  kt-badge kt-badge--success kt-badge-sm kt-badge--outline kt-badge--pill
                "
              >
                {{ r.posted_quotes_count }} Quotations</span
              >
            </div>
          </td>

          <td>
            <div class="pipeline" *ngFor="let p of r.pipelinesObj">
              <span class="p">
                {{ p.pipeline.label }}
              </span>
              <span class="s">
                {{ p.stage.stage }}
              </span>
            </div>
          </td>

          <td *ngIf="authService.loginUser.role >= 2">
            <div class="sourcing">
              <ul *ngIf="r.admins && r.admins.length > 0">
                <li *ngFor="let admin of r.admins">
                  <span *ngIf="admin.users && admin.users.firstname">
                    {{ admin.users.firstname }}
                    {{ admin.users.lastname }}
                  </span>
                </li>
              </ul>
              <ul *ngIf="r.members && r.members.length > 0">
                <li *ngFor="let member of r.members">
                  <span *ngIf="member.users && member.users.firstname">
                    {{ member.users.firstname }}
                    {{ member.users.lastname }}
                  </span>
                </li>
              </ul>
            </div>
          </td>

          <td class="actions text-right">
            <div ngbDropdown class="d-inline-block" *ngIf="!checked[r.id]">
              <button
                ngbDropdownToggle
                mat-mini-fab
                type="button"
                color="default"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="flaticon-more-1"></i>
              </button>

              <div ngbDropdownMenu aria-labelledby="action-button">
                <button
                  ngbDropdownItem
                  (click)="editRfq(r)"
                  *ngIf="authService.loginUser.prwx == 7"
                >
                  <i class="fas fa-edit"></i> Edit SKU
                </button>
                <button
                  ngbDropdownItem
                  (click)="editPipelines(r)"
                  *ngIf="authService.loginUser.prwx == 7"
                >
                  <i class="fas fa-signal"></i> Update Pipelines
                </button>
                <button
                  ngbDropdownItem
                  (click)="addQuotation(r)"
                  *ngIf="
                    authService.loginUser.role != 2 &&
                    authService.loginUser.prwx == 7
                  "
                >
                  <i class="fas fa-plus"></i> Add Quotation
                </button>
                <button ngbDropdownItem (click)="showDetails(r, 'quotations')">
                  <i class="fas fa-file-alt"></i>
                  View Quotations
                </button>
                <button
                  ngbDropdownItem
                  (click)="assignRFQ(r)"
                  *ngIf="
                    authService.loginUser.role >= 88 &&
                    authService.loginUser.prwx == 7
                  "
                >
                  <i class="fas fa-user-friends"></i> Assign SKU Admin
                </button>
                <button
                  ngbDropdownItem
                  (click)="assignRFQ(r)"
                  *ngIf="
                    authService.loginUser.role == 8 &&
                    authService.loginUser.prwx == 7
                  "
                >
                  <i class="fas fa-user-friends"></i> Assign SKU Member
                </button>
                <button
                  ngbDropdownItem
                  (click)="exportRfqToPDF(r)"
                  class="text-info"
                >
                  <i class="fas fa-file-pdf text-info"></i>
                  Export to PDF
                </button>
                <button
                  ngbDropdownItem
                  (click)="discontinue(r)"
                  *ngIf="
                    r.is_discontinued == 0 &&
                    authService.loginUser.is_admin &&
                    authService.loginUser.prwx == 7
                  "
                  class="text-warning"
                >
                  <i class="fas fa-stop text-warning"></i>
                  Discontinue SKU
                </button>
                <button
                  ngbDropdownItem
                  (click)="continue(r)"
                  *ngIf="
                    r.is_discontinued == 1 &&
                    authService.loginUser.is_admin &&
                    authService.loginUser.prwx == 7
                  "
                  class="text-info"
                >
                  <i class="fas fa-play text-info"></i>
                  Undiscontinue SKU
                </button>
                <button
                  ngbDropdownItem
                  (click)="delete(r)"
                  *ngIf="
                    authService.loginUser.is_admin &&
                    authService.loginUser.prwx == 7
                  "
                  class="text-danger"
                >
                  <i class="fas fa-trash text-danger"></i>
                  Delete SKU
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <mat-paginator
    [length]="rfqRecord.total"
    [pageSize]="rfqRecord.per_page"
    [pageSizeOptions]="pageSizeOptions"
    (page)="getRecords($event)"
  >
  </mat-paginator>
</div>
